/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Lpminimumticketsize4Inputs */

const en_coinvestments_tracking_lpminimumticketsize4 = /** @type {(inputs: Coinvestments_Tracking_Lpminimumticketsize4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Min. Ticket Size" |
*
* @param {Coinvestments_Tracking_Lpminimumticketsize4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_lpminimumticketsize4 = /** @type {((inputs?: Coinvestments_Tracking_Lpminimumticketsize4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Lpminimumticketsize4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_lpminimumticketsize4(inputs)
});
export { coinvestments_tracking_lpminimumticketsize4 as "coInvestments_tracking_lpMinimumTicketSize" }